import { render, staticRenderFns } from "./MostCommonlyQuestion.vue?vue&type=template&id=47dd91f3&"
import script from "./MostCommonlyQuestion.vue?vue&type=script&lang=js&"
export * from "./MostCommonlyQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports